import { useEffect } from "react";
import { useAppDispatch } from "../../../core/redux/hooks/useAppDispatch";
import { actionSetScale } from "../slice";

export function useResizeScale(
  containerRef: React.RefObject<HTMLDivElement | null>,
  fullHeight: number
) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const el = containerRef?.current;
    if (!el) return;

    const resizeHandler = () => {
      const coef = el.clientHeight / fullHeight;
      el.style.setProperty("--bg-scale", String(coef));
      dispatch(actionSetScale(coef));
    };

    const observer = new ResizeObserver(resizeHandler);
    observer.observe(el);

    resizeHandler();

    return () => {
      observer.unobserve(el);
    };
  }, [containerRef, fullHeight, dispatch]);
}
